<br>
<highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions"
                  style="width: 100%; height: 230px; display: block;"></highcharts-chart>
